import { SvgIcon, type SvgIconProps } from './svgIcon'

const VIEWBOX_SIZE = 28

export function WarningIcon({
  width = VIEWBOX_SIZE,
  height = VIEWBOX_SIZE,
  ...props
}: SvgIconProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      {...props}>
      <rect
        width={VIEWBOX_SIZE}
        height={VIEWBOX_SIZE}
        rx={VIEWBOX_SIZE / 2}
        fill="currentColor"
      />
      <path
        d="M14 7V16.3333"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M14 18.666V20.9993"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </SvgIcon>
  )
}
